import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputLabel, OutlinedInput, MenuItem, Select, CircularProgress, Modal, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    title:{
        fontSize: "20px",
        textAlign: "center",
        color:  theme.palette.primary.main,
        marginBottom:"7%"
    },
    buttonProgress:{
marginLeft:'50%'
    }
}));

export const AñadirCapacidadModal = ({ open, handleClose, dataEdit, createCapacidad, numeroDocumento, Basculas }) => {
    const classes = useStyles();
    const [isLoanding, setisLoanding] = useState(false);
    const decimalRegEx = /^\d{0,2}(\.\d{0,2})?$/;


    return (
        <Modal open={open} onClose={handleClose}>
            <div className={classes.paper}>
                <Typography className={classes.title}>Registrar medición capacidad pulmonar</Typography>
                <Formik
                    initialValues={{
                        Evbi: "",
                        Pef: "",
                        Pred: "",
                        Porcentaje: ""
                    }}

                    validate={(valores) => {
                        let errores = {};

                        const decimalRegEx = /^\d{0,2}(\.\d{0,2})?$/;
                        if (!valores.Pred) {
                            errores.Pred = 'Por favor ingresa un valor numérico para la Pred';
                        } else if (!decimalRegEx.test(valores.Pred)) {
                            errores.Pred = 'Pred debe tener hasta dos dígitos con dos decimales';
                        }

                        if (!valores.Pef) {
                            errores.Pef = 'Por favor ingresa un valor numérico para la Pef';
                        } else if (!decimalRegEx.test(valores.Pef)) {
                            errores.Pef = 'Pef debe tener hasta dos dígitos con dos decimales';
                        }

                        if (!valores.Evbi) {
                            errores.Evbi = 'Por favor selecciona una Evbi';
                        }

                        if (!valores.Porcentaje) {
                            errores.Porcentaje = 'Por favor ingresa un valor numérico para el porcentaje';
                        } else if (valores.Porcentaje > 100) {
                            errores.Porcentaje = 'El porcentaje no puede ser mayor a 100';
                        }

                        return errores;
                    }}

                    onSubmit={(valores, { resetForm }) => {
                        setisLoanding(true);

                        const data = {
                            evbi: valores.Evbi,
                            numeroDocumento: numeroDocumento,
                            pef: valores.Pef,
                            pred: valores.Pred,
                            porcentaje: valores.Porcentaje
                        };

                        createCapacidad(data);
                        valores.isLoading = true;
                        setTimeout(() => {
                            setisLoanding(false);
                            handleClose();
                        }, 500);

                        resetForm();
                    }}
                >
                    {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3} style={{ textAlign: "left" }}>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Pred">Pred</InputLabel>
                                        <OutlinedInput
                                            id="Pred"
                                            name="Pred"
                                            value={values.Pred}
                                            onChange={(e) => {
                                                if (decimalRegEx.test(e.target.value) || e.target.value === '') {
                                                    handleChange(e);
                                                }
                                            }}
                                            onBlur={handleBlur}
                                            labelWidth={100}
                                            inputProps={{
                                                step: "0.01",
                                                min: "0",
                                                max: "99.99",
                                                maxLength: 5
                                            }}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </FormControl>
                                    {touched.Pred && errors.Pred && <div style={{ color: "red" }}>{errors.Pred}</div>}
                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Pef">Pef</InputLabel>
                                        <OutlinedInput
                                            id="Pef"
                                            name="Pef"
                                            value={values.Pef}
                                            onChange={(e) => {
                                                if (decimalRegEx.test(e.target.value) || e.target.value === '') {
                                                    handleChange(e);
                                                }
                                            }}
                                            onBlur={handleBlur}
                                            labelWidth={100}
                                            inputProps={{
                                                step: "0.01",
                                                min: "0",
                                                max: "99.99",
                                                maxLength: 5
                                            }}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </FormControl>
                                    {touched.Pef && errors.Pef && <div style={{ color: "red" }}>{errors.Pef}</div>}
                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Porcentaje">Porcentaje</InputLabel>
                                        <OutlinedInput
                                            id="Porcentaje"
                                            name="Porcentaje"
                                            value={values.Porcentaje}
                                            onChange={(e) => {
                                                if (/^\d{0,3}$/.test(e.target.value) || e.target.value === '') {
                                                    handleChange(e);
                                                }
                                            }}
                                            onBlur={handleBlur}
                                            labelWidth={100}
                                            inputProps={{
                                                step: "1",
                                                min: "0",
                                                max: "100",
                                                maxLength: 3
                                            }}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </FormControl>
                                    {touched.Porcentaje && errors.Porcentaje && <div style={{ color: "red" }}>{errors.Porcentaje}</div>}
                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Evbi">Evbi</InputLabel>
                                        <Select
                                            id="Evbi"
                                            name="Evbi"
                                            value={values.Evbi}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            labelWidth={70}
                                            style={{ borderRadius: '10px' }}
                                        >
                                            {Basculas.map((bascula) => (
                                                <MenuItem key={bascula.id} value={bascula.id}>{bascula.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {touched.Evbi && errors.Evbi && <div style={{ color: "red" }}>{errors.Evbi}</div>}
                                </Grid>
                            </Grid>
                            <div className={classes.wrapper}>
                                <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                                    <Button
                                        disabled={isLoanding}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        style={{ textTransform: "none", width: "50%", borderRadius: '10px' }}
                                    >
                                        Registrar
                                    </Button>
                                </Grid>
                                {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </Modal>
    );
};